import { StatusBarProps } from './StatusBar.types'
import React from 'react'
import ButtonSquare from '../../../components/common/ButtonSquare/ButtonSquare'
import Steps from './Steps/Steps'
import { StatusBarContainer, Heading } from './StatusBar.styles'
import { useTranslation } from 'react-i18next'

const StatusBar: React.FC<StatusBarProps> = ({
  handleClose,
  heading,
  steps,
  currentStep,
}) => {
  const { t } = useTranslation()
  return (
    <StatusBarContainer>
      <ButtonSquare onClick={handleClose} btntype='white' />
      <Heading variant='body1'>{t(heading)}</Heading>
      <Steps steps={steps} currentStep={currentStep} />
    </StatusBarContainer>
  )
}

export default StatusBar
